import { CERT_ACCESS } from '../../server/src/routes/app/src/getTypeAccess.js';
import { getFormTypeAccess } from './getFormTypeAccess.js';

export function isCertAccess() {
  return getFormTypeAccess() === CERT_ACCESS;
}
